import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import HeaderTitle from "./HeaderTitle";
import MoldCorner from "./MoldCorner";
import MoldDialog from "./MoldDialog";
import MoldFamily from "./MoldFamily";
import SunIcon from "./SunIcon";
import Survey from "./Survey";
import Main from "./Main";
import HomePage from "./HomePage";
import Kitchen from "./pages/Kitchen";
import Bathroom from "./pages/Bathroom";
import Bedroom from "./pages/Bedroom";
import Items from "./pages/Items";
import Garden from "./pages/Garden";
import Diagnosis from './pages/Diagnosis';
import "./App.css";
import Footer from "./components/Footer";


function App() {
  return (
    <GoogleReCaptchaProvider reCaptchaKey="6LcDdY0rAAAAANtCVZlM52N-CkLzlXbg8fenOPTb">
      <div className="app-root">
        <Router>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/survey" element={<Survey />} />
            <Route path="/main" element={<Main />} />
            <Route path="/main/kitchen" element={<Kitchen />} />
            <Route path="/main/bathroom" element={<Bathroom />} />
          <Route path="/main/bedroom" element={<Bedroom />} />
          <Route path="/main/items" element={<Items />} />
          <Route path="/main/garden" element={<Garden />} />
          <Route path="/diagnosis" element={<Diagnosis />} />
          <Route path="/footer" element={<Footer />} />
        </Routes>
      </Router>
      <Footer />
    </div>
    </GoogleReCaptchaProvider>
  );
}

export default App;
